
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lp-ui-contact-completed",
      function () {
        return require("private-next-pages/lp-ui-contact-completed.tsx");
      }
    ]);
  